export enum MediaQueryBreakpoints {
  MobileMax = 480,
  TabletsMin = 768,
  TabletsMax = 1024,
}

export const PREDEFINED_QUERIES = {
  isTabletOrLess: `max-width: ${MediaQueryBreakpoints.TabletsMax}px`,
  isMobile: `max-width: ${MediaQueryBreakpoints.TabletsMin}px`,
  isDesktop: `min-width: ${MediaQueryBreakpoints.TabletsMax}px`,
};
